import state from "./moduleInvoicesManagementState";
import mutations from "./moduleInvoicesManagementMutations";
import actions from "./moduleInvoicesManagementActions";

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
